export default function CarouselSkeleton({
  title,
  description,
  showNavigation = true,
  itemCount = 4,
}) {
  return (
    <div className="animate-pulse">
      {/* Header */}
      <div className="mb-6 flex flex-col gap-2">
        {title ? (
          <h2 className="h-8 w-auto rounded bg-gray-200 text-transparent">
            {title}
          </h2>
        ) : (
          <div className="h-8 w-64 rounded bg-gray-200"></div>
        )}
        {description && <div className="h-4 w-96 rounded bg-gray-200"></div>}
        {showNavigation && (
          <div className="mt-2 flex items-center justify-between">
            <div className="h-4 w-24 rounded bg-gray-200"></div>
            <div className="flex gap-2">
              <div className="h-8 w-8 rounded bg-gray-200"></div>
              <div className="h-8 w-8 rounded bg-gray-200"></div>
            </div>
          </div>
        )}
      </div>

      {/* Items */}
      <div className="flex gap-4 overflow-hidden">
        {[...Array(itemCount)].map((_, i) => (
          <div
            key={i}
            className="h-48 w-72 flex-shrink-0 rounded-lg bg-gray-200"
          ></div>
        ))}
      </div>
    </div>
  );
}

